module.exports = __webpack_public_path__ + "media/images/dashboard/xpass_banner_bg_2-aae0ccd1403f05a1e513fec4875a8b54.png";